module.exports = __webpack_public_path__ + "img/ícone-seta-esquerda-primeiro-azul.12724e04.svg";